import { styled } from "@mui/material";

interface AccordionItemProps {
  isActive: boolean;
}

interface AnswerProps {
  isActive: boolean;
}

export const AccordionContainer = styled("div")(({ theme }) => ({
  background: `linear-gradient(
    -45deg,
    ${theme.palette.color.cyan.light},
    ${theme.palette.color.cyan.medium}
  )`,
  borderRadius: "1rem",
  padding: "1rem 2rem 2rem 2rem",
  width: "100%",

  "@media (max-width: 720px)": {
    padding: "1rem 0",
  },
}));

export const AccordionItem = styled("div")<AccordionItemProps>(
  ({ theme, isActive }) => ({
    borderBottom: `1px solid ${theme.palette.color.cyan.light}`,

    "& h4": {
      margin: 0,
      color: isActive ? theme.palette.color.main.primary : "inherit",
    },
  }),
);

export const Question = styled("div")<{ isActive?: boolean }>(
  ({ isActive }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem 0",

    "& span": {
      transition: "transform 0.3s ease",
      transform: isActive ? "rotate(180deg)" : "none",
    },

    "@media (max-width: 720px)": {
      textAlign: "left",
      alignItems: "flex-start",
      fontSize: "1rem",
    },
  }),
);

export const Answer = styled("div")<AnswerProps>(({ isActive }) => ({
  position: "relative",
  overflow: "hidden",
  textAlign: "left",
  padding: 0,
  height: isActive ? "auto" : 0,
  fontWeight: 400,

  "& > div": {
    padding: isActive ? "0 0 1rem 0" : 0,
    opacity: isActive ? 1 : 0,
    transform: isActive ? "translateY(0)" : "translateY(-100%)",
    transition:
      "transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.5s ease, padding 0.5s ease",
  },
}));
